import * as React from "react";
import Dropdown from "../Dropdown/Dropdown";
import DualRange from "../DualRange/DualRange";
import Input from "../Input-new/Input";
import { getOptionsType } from "../Dropdown/optionTypes";

export const LENDER_TYPE = 'Lender';

export const LOAN_CRITERIA_COLUMNS = [
  'LOAN_TYPES',
  'LOAN_STATES',
  'LOAN_CATEGORIES',
  'LOAN_PROPERTY_TYPES',
  'LOAN_AMOUNT_MIN',
  'LOAN_AMOUNT_MAX',
  'LOAN_RATE',
];

// The client asked for the 50 states, so Washington DC is left out.
const STATES = getOptionsType('states').filter((state) => state.abbr !== 'DC');

export function isLender(data) {
  return Boolean(data) && data.VENDOR_TYPE === LENDER_TYPE;
}

const VendorLoanCriteria = ({ data, handleChangeInput, handleChangeDropdown, viewMode, deleted }) => (
  <div className="vendor-info">
    <div className="vendor-info_column">
      <Dropdown
        className="vendor-info_column_item"
        dropdownType="multiple"
        data={data}
        optionsType="lenderLoanType"
        value={data.LOAN_TYPES}
        valueKey="LOAN_TYPES"
        label="Loan Type"
        handleParentChange={handleChangeDropdown}
        viewMode={viewMode}
        deleted={deleted}
      />
      <Dropdown
        className="vendor-info_column_item"
        dropdownType="multiple"
        data={data}
        optionsType="states"
        options={STATES}
        optionKey="abbr"
        optionLabelKey="name"
        value={data.LOAN_STATES}
        valueKey="LOAN_STATES"
        label="States"
        handleParentChange={handleChangeDropdown}
        viewMode={viewMode}
        deleted={deleted}
      />
      <Dropdown
        className="vendor-info_column_item"
        dropdownType="multiple"
        data={data}
        optionsType="category"
        optionKey="code"
        optionLabelKey="name"
        value={data.LOAN_CATEGORIES}
        valueKey="LOAN_CATEGORIES"
        label="Category"
        handleParentChange={handleChangeDropdown}
        viewMode={viewMode}
        deleted={deleted}
      />
      <Dropdown
        className="vendor-info_column_item"
        dropdownType="multiple"
        data={data}
        optionsType="type"
        optionKey="code"
        optionLabelKey="name"
        value={data.LOAN_PROPERTY_TYPES}
        valueKey="LOAN_PROPERTY_TYPES"
        label="Type"
        handleParentChange={handleChangeDropdown}
        viewMode={viewMode}
        deleted={deleted}
      />
      <DualRange
        className="vendor-info_column_item"
        minValue={data.LOAN_AMOUNT_MIN || ''}
        maxValue={data.LOAN_AMOUNT_MAX || ''}
        minName="LOAN_AMOUNT_MIN"
        maxName="LOAN_AMOUNT_MAX"
        valueType="integer"
        label="Loan Amount"
        handleParentChange={handleChangeInput}
        viewMode={viewMode}
        deleted={deleted}
        isDollar
      />
      <Input
        className="vendor-info_column_item"
        type="text"
        valueType="percent"
        name="LOAN_RATE"
        label="Rate"
        value={data.LOAN_RATE}
        handleParentChange={handleChangeInput}
        viewMode={viewMode}
        deleted={deleted}
        decimals={3}
      />
    </div>
  </div>
);

export default VendorLoanCriteria;
